import React, { useEffect } from 'react';
import { View } from 'react-native';

import { QuickActionMenu, VFText, VFButton } from '@vfgroup-oneplatform/foundation/Components';
import { TypesList } from '@vfgroup-oneplatform/foundation/Components/Themes/Types';
import ContentManager from '@vfgroup-oneplatform/foundation/ContentManager';
import { isFunction as _isFunction } from 'lodash';
import PropTypes from 'prop-types';

import { BillingTrackingManager } from '../../Utils';
import BillingTestKeys from '../../Utils/BillingTestKeys.js';

import styles from './NegativeBillQuickAction.Styles';

const commonTrackingData = {
  page_name: 'My Bills',
  page_section: 'Billing:Negative Bill Quick Action',
};

const NegativeBillQuickAction = ({
  isVisible,
  toggleModal,
  closeModal,
  QAtitle,
  title,
  description,
  buttonTitle,
  getAdditionalTrackingData,
  withCloseButton,
  QAtitleStyle,
  titleStyle,
  descriptionStyle,
  buttonStyle = {},
  buttonType,
  descriptionContainerStyle,
}) => {
  useEffect(() => {
    if (isVisible) {
      const additionalData = _isFunction(getAdditionalTrackingData) && getAdditionalTrackingData();
      BillingTrackingManager.trackView('Info pop-up', {
        ...commonTrackingData,
        ...additionalData,
      });
    }
  }, [isVisible]);

  const onCloseButtonPress = () => {
    const additionalData = _isFunction(getAdditionalTrackingData) && getAdditionalTrackingData();
    const data = {
      event_action: 'OnClick',
      event_category: 'Button',
      event_label: ContentManager.translate(buttonTitle),
      ...commonTrackingData,
      ...additionalData,
    };
    BillingTrackingManager.trackEvent('ui_interaction', data);
    closeModal();
  };
  return (
    <QuickActionMenu
      isVisible={isVisible}
      toggleModal={toggleModal}
      closeModal={closeModal}
      title={QAtitle}
      TitleAccessibilityLabel={BillingTestKeys.negativeBillQuickActionTitle}
      type="secondary"
      headerStyle={[styles.QAHeader, QAtitleStyle]}
      closeIconAccessibilityLabel={'CloseIcon'}
      quickActionMenuCloseIconTestID={BillingTestKeys.negativeBillQuickActionCloseIcon}
      withCloseButton={withCloseButton}
      testID={BillingTestKeys.negativeBillQAM}
    >
      <View style={styles.container} testID={BillingTestKeys.negativeBillQAMTitleView}>
        <VFText
          i18nKey={title}
          type="primary"
          style={[styles.title, titleStyle]}
          testKey={BillingTestKeys.negativeBillQAMTitleText}
        />
        <View style={descriptionContainerStyle} testID={BillingTestKeys.negativeBillQAMDescView}>
          <VFText
            i18nKey={description}
            type="primary"
            style={[styles.description, descriptionStyle]}
            testKey={BillingTestKeys.negativeBillQAMDescText}
          />
        </View>
        <VFButton
          title={buttonTitle}
          onPress={onCloseButtonPress}
          type={buttonType ?? 'secondary'}
          style={[styles.button, buttonStyle]}
          textStyle={buttonStyle.textStyle}
          testKey={BillingTestKeys.negativeBillQAMCloseBTN}
        />
      </View>
    </QuickActionMenu>
  );
};
NegativeBillQuickAction.propTypes = {
  isVisible: PropTypes.bool,
  toggleModal: PropTypes.func,
  closeModal: PropTypes.func,
  QAtitle: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  buttonTitle: PropTypes.string,
  getAdditionalTrackingData: PropTypes.func,
  withCloseButton: PropTypes.bool,
  buttonStyle: PropTypes.object,
  QAtitleStyle: PropTypes.object,
  titleStyle: PropTypes.object,
  descriptionStyle: PropTypes.object,
  descriptionContainerStyle: PropTypes.object,
  buttonType: PropTypes.oneOf(TypesList),
};
export default NegativeBillQuickAction;
